import React, {useState} from 'react';

//Component
import ChatBox from './chatBox';
import './chatContainer.css';
import './chatComponent.css';

const ChatContainerRender = ({
  state,
  props,
  refToChatBoxFnc,
  setOfflineClientRoomDto,
  updateChatMessages,
  updateReadMessagesByMessageTag,
  handleTransitionChatRoomOwnership,
  handleTaskOwnerLockChange,
  showLeadCollector,
  callSendMessageFunc,
  callbackSuccessInfoSend,
}) => {
  const [dragStarted, setDragStarted] = useState(false);
  const [currentSelectedFile, setCurrentSelectedFile] = useState(null);
  const [showSendFileComponent, setShowSendFileComponent] = useState(false);

  const onFileDrag = (value) => {
    setDragStarted(value);
  };
  const handleFileDrop = (file) => {
    setCurrentSelectedFile(file);
    setShowSendFileComponent(true);
  };

  const openCloseSendFileComponent = (currentStateToShowPopup, file) => {
    setCurrentSelectedFile(file);
    setShowSendFileComponent(currentStateToShowPopup);
  };
  return (
    <React.Fragment>
      <div
        className="et-chat-chatting"
        onDrop={(e) => {
          e.preventDefault();
          // Check if it's inside widget
          setDragStarted(false);
          if (e.dataTransfer.files.length > 0) {
            handleFileDrop(e.dataTransfer.files[0]);
          }
        }}
        onDragOver={(e) => {
          e.preventDefault();
        }}
        onPaste={(event) => {
          var items = (event.clipboardData || event.originalEvent.clipboardData)
            .items;
          for (let index in items) {
            var item = items[index];
            if (item.kind === 'file') {
              var blob = item.getAsFile();
              handleFileDrop(blob);
            }
          }
        }}>
        {Object.keys(state.chatBoxes).map((roomId, index) => {
          return (
            // We should not load all the chat room in dom and hide them, this is bad practice
            (state.selectedChatRoomDto?.roomId === roomId ||
              props.selectedRoomDto?.roomId === roomId) && (
              <div
                key={roomId}
                className={
                  state.selectedChatRoomDto?.roomId !== roomId &&
                  props.selectedRoomDto?.roomId !== roomId
                    ? 'et-chatHidden'
                    : `et-chat-visible ${!state.chatBoxes[roomId].isMentor ? 'et-chat-visible-client' : ''}`
                }>
                <ChatBox
                  onRef={refToChatBoxFnc}
                  isDemo={props.isDemo}
                  fncObj={state.chatBoxes[roomId].fncObjToChatBox}
                  chatBoxIsHidden={
                    state.selectedChatRoomDto?.roomId !== roomId &&
                    props.selectedRoomDto?.roomId !== roomId
                  }
                  // start here
                  chatRoomDto={state.chatBoxes[roomId].chatRoomDto}
                  chatRooms={props.chatRooms}
                  peerUserId={state.chatBoxes[roomId].peerUserId}
                  currentUser={state.chatBoxes[roomId].currentUser}
                  peerName={state.chatBoxes[roomId].peerName}
                  isMentor={state.chatBoxes[roomId].isMentor}
                  roomType={state.chatBoxes[roomId].roomType}
                  roomId={state.chatBoxes[roomId].roomId}
                  firstMessage={state.chatBoxes[roomId].firstMessage}
                  chatMessages={state.chatBoxes[roomId].chatMessages}
                  updateChatMessages={(chatMessages) =>
                    updateChatMessages(roomId, chatMessages)
                  }
                  readMessagesByMessageTag={
                    state.chatBoxes[roomId].readMessagesByMessageTag
                  }
                  updateReadMessagesByMessageTag={(readMessagesByMessageTag) =>
                    updateReadMessagesByMessageTag(
                      roomId,
                      readMessagesByMessageTag,
                    )
                  }
                  automaticMessage={state.chatBoxes[roomId].automaticMessage}
                  nonRespondantMessage={
                    state.chatBoxes[roomId].nonRespondantMessage
                  }
                  nonRespondantMessageTime={
                    state.chatBoxes[roomId].nonRespondantMessageTime
                  }
                  sendAnalyticsToParent={
                    state.chatBoxes[roomId].sendAnalyticsToParent
                  }
                  // end here

                  key={index}
                  updateChatBoxNameInList={props.updateChatBoxNameInList}
                  updateChatRoomLastMessage={props.updateChatRoomLastMessage}
                  updateChatRoomReadersReadMessagesMap={
                    props.updateChatRoomReadersReadMessagesMap
                  }
                  mentor={props.mentor}
                  dispatchConsoltoEvents={props.dispatchConsoltoEvents}
                  selectedWidgetAppType={props.selectedWidgetAppType}
                  roomDtoFromChatCenter={props.selectedRoomDto}
                  openCloseSendFileComponent={(
                    currentStateToShowPopup,
                    file,
                  ) => {
                    openCloseSendFileComponent(currentStateToShowPopup, file);
                    props.openCloseSendFileComponent &&
                      props.openCloseSendFileComponent(
                        currentStateToShowPopup,
                        file,
                      );
                  }}
                  currentSelectedFile={
                    props.currentSelectedFile === undefined
                      ? currentSelectedFile
                      : props.currentSelectedFile
                  }
                  showSendFileComponent={
                    props.showSendFileComponent === undefined
                      ? showSendFileComponent
                      : props.showSendFileComponent
                  }
                  handleChatRoomExtendedInfoChange={
                    props.handleChatRoomExtendedInfoChange
                  }
                  onFileDrag={onFileDrag}
                  setOfflineClientRoomDto={setOfflineClientRoomDto}
                  updatedChatRoomDto={props.updatedChatRoomDto}
                  isTakeOwnershipFlowRunning={props.isTakeOwnershipFlowRunning}
                  handleTransitionChatRoomOwnership={
                    handleTransitionChatRoomOwnership
                  }
                  handleTaskOwnerLockChange={handleTaskOwnerLockChange}
                  handleTransitionToMentorChat={
                    props.handleTransitionToMentorChat
                  }
                  showLeadCollector={showLeadCollector}
                  isPersonalPage={props.isPersonalPage}
                  callSendMessageFunc={callSendMessageFunc}
                  callbackSuccessInfoSend={callbackSuccessInfoSend}
                  doWhenActionClick={props.doWhenActionClick}
                  onFooterOptionSelected={props.onFooterOptionSelected}
                  setIsChatActive={props.setIsChatActive}
                />
              </div>
            )
          );
        })}
        {(dragStarted || props.dragStarted) && !props.isInWidget && (
          <div className={`et-chat-container-overlay-file-drop`}>
            <div className="et-chat-container-overlay-file-drop-text">
              Drag File Here
            </div>
          </div>
        )}
      </div>
      {/* </div> */}
    </React.Fragment>
  );
};

export default ChatContainerRender;
